import { FormControlProps, FormControl, MenuItem, Select } from '@mui/material'
import { MenuItemDivider } from './MenuItemDivider'

export interface IMenuItem {
  value: string
  text: string
  [key: string]: string | number
}

interface IProps extends FormControlProps {
  items: IMenuItem[]
  label?: string
  name?: string
  noneOption?: boolean
  noneOptionLabel?: string
  value: string | string[]
  onChange: (e: any) => void
  FormControlComponent?: typeof FormControl
}

export const GenericSelect = ({
  items,
  label = '',
  name = 'value',
  noneOption = false,
  noneOptionLabel = 'None',
  value,
  onChange,
  FormControlComponent = FormControl,
  ...props
}: IProps) => {
  const inputLabelId = `${label?.toLowerCase().replace(/ /g, '-') || 'the'}-select-label`
  return (
    <FormControlComponent {...props}>
      <Select
        variant="standard"
        labelId={inputLabelId}
        name={name}
        value={value}
        onChange={onChange}
        // Fix maximum call stack error on selecting no value.
        MenuProps={{ disablePortal: true }}
        size="small"
        inputProps={{ 'aria-label': label }}
        displayEmpty={true}
        data-testid="select"
      >
        {noneOption
          ? [
              <MenuItem key="MenuItem-NoneOptionKey" value="" data-testid="menu-item-none-option">
                <em>{noneOptionLabel}</em>
              </MenuItem>,
              <MenuItemDivider key="MenuItemDivider" />,
            ]
          : null}
        {items.map(item => (
          <MenuItem key={item.value} value={item.value} data-testid="menu-item">
            {item.text}
          </MenuItem>
        ))}
      </Select>
    </FormControlComponent>
  )
}
